export default __webpack_public_path__ + "static/logo-9e27e4cd9bb724c81b45a2128743b40b.svg";